<template>
    <div class="popup">
        <div id="scrollPart" class="card">
            <!--ARROW-->
            <div class="back-arrow">
                <img src="@/assets/arrow-back.svg" alt="back icon" @click="backProfile" />
                <!--  <p @click="editBlog">Edit</p> -->
            </div>
            <div style="border: 1px solid rgba(255, 255, 255, 0.2)">
                <!--ROW_ONE-->
                <div class="row-one">
                    <div class="row-one-left flex-center">
                        <h2>{{ currentBlog.title }}</h2>

                        <p>
                            {{ currentBlog.description }}
                        </p>
                    </div>
                    <img class="svg_img" src="@/assets/Wallet-illustration.svg" alt="chess illustration" />
                </div>

                <Transition name="fade" mode="out-in">
                    <div v-if="currentBlog.image" class="top">
                        <img :src="currentBlog.image" alt="" />
                    </div>
                </Transition>
                <!--NEW POST-->

                <!--ROW_BOTTOM-->
                <div class="bottom">
                    <p class="paragraph" v-html="markdownContent" />
                </div>

                <!--ROW_NAVIGATION-->
                <div class="navigation-row">
                    <div v-if="firstPage" @click="backProfile">
                        <svg
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="#6f7381"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5.59766 0.662695L6.29766 1.36269L2.22266 5.46269L15.0977 5.4627L15.0977 6.4627L2.22266 6.46269L6.29766 10.5627L5.59766 11.2627L0.297657 5.96269L5.59766 0.662695Z"
                                fill="white"
                            />
                        </svg>
                        <p>Back to page</p>
                    </div>
                    <div v-else>
                        <div class="mobile" @click="previusBlog('mobile')">
                            <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="#6f7381"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.59766 0.662695L6.29766 1.36269L2.22266 5.46269L15.0977 5.4627L15.0977 6.4627L2.22266 6.46269L6.29766 10.5627L5.59766 11.2627L0.297657 5.96269L5.59766 0.662695Z"
                                    fill="white"
                                />
                            </svg>

                            <p>Previus post</p>
                        </div>
                        <div class="desktop" @click="previusBlog('desktop')">
                            <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="#6f7381"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.59766 0.662695L6.29766 1.36269L2.22266 5.46269L15.0977 5.4627L15.0977 6.4627L2.22266 6.46269L6.29766 10.5627L5.59766 11.2627L0.297657 5.96269L5.59766 0.662695Z"
                                    fill="white"
                                />
                            </svg>

                            <p>Previus post</p>
                        </div>
                    </div>
                    <div>
                        <div v-if="!noNext" class="mobile" @click="nextBlog('mobile')">
                            <p>Next post</p>
                            <svg
                                width="16"
                                height="11"
                                viewBox="0 0 16 11"
                                fill="#6f7381"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.79688 10.7689L9.09687 10.0689L13.1719 5.96895L0.296875 5.96895L0.296875 4.96895L13.1719 4.96895L9.09687 0.868946L9.79688 0.168945L15.0969 5.46895L9.79688 10.7689Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <div v-if="!noNext" class="desktop" @click="nextBlog('desktop')">
                            <p>Next post</p>
                            <svg
                                width="16"
                                height="11"
                                viewBox="0 0 16 11"
                                fill="#6f7381"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.79688 10.7689L9.09687 10.0689L13.1719 5.96895L0.296875 5.96895L0.296875 4.96895L13.1719 4.96895L9.09687 0.868946L9.79688 0.168945L15.0969 5.46895L9.79688 10.7689Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <!--END NAVIGATION-->
        </div>
    </div>
</template>

<script>
import { marked } from "marked";
export default {
    name: "BlogCard",
    props: ["blog", "blogNumber"],
    data() {
        return {
            blogNumberIndex: "",
            currentBlog: "",
            noNext: false,
            firstPage: false,
            text: "",
            text2: "",
        };
    },
    computed: {
        markdownContent() {
            return marked(this.text);
        },
    },
    mounted() {
        // console.log("wow", this.blog);
        this.text2 = this.blog.content_md;

        // this.text = this.text2; //.replace( /(\n\n)\b/g, '<br>')
        if (this.text2.includes("---") || this.text2.includes("===") || this.text2.includes("###")) {
            this.text = this.text2;
        } else {
            this.text = this.text2.replaceAll(/\n\n/g, "<br><br> ");
        }
        //  console.log(this.text);
        this.blogNumberIndex = this.blogNumber;
        this.currentBlog = this.blog;
        this.length = this.$store.state.my_blogs.length;
        //  console.log(this.currentBlog.content_md);
        if (this.blogNumber == 0) {
            this.firstPage = true;
        }
        if (this.length == this.blogNumberIndex + 1) {
            this.noNext = true;
        }
    },

    methods: {
        backProfile() {
            this.$emit("noPopup");
        },
        nextBlog(e) {
            if (e == "mobile") {
                var targetMobile = document.querySelector(".card");
                targetMobile.scrollIntoView({ behavior: "smooth" });
            } else {
                var targetDesktop = document.querySelector(".popup");
                targetDesktop.scrollIntoView({ behavior: "smooth" });
            }

            if (this.length > this.blogNumberIndex + 1) {
                this.currentBlog = this.$store.state.my_blogs[this.blogNumberIndex + 1];
                console.log("roki", this.currentBlog);
                this.blogNumberIndex++;
                this.firstPage = false;
                this.text = this.currentBlog.content_md;
                // window.history.pushState({}, '',`/publicprofile/${this.currentBlog.created_by}`+ `/${this.currentBlog.blog_post_uuid}` );
            }
            if (this.length == this.blogNumberIndex + 1) {
                this.noNext = true;
            }
        },
        previusBlog(e) {
            if (this.length == this.blogNumberIndex + 1) {
                this.noNext = false;
            }
            this.currentBlog = this.$store.state.my_blogs[this.blogNumberIndex - 1];
            this.text = this.currentBlog.content_md;
            this.blogNumberIndex--;
            //  window.history.pushState({}, '',`/publicprofile/${this.currentBlog.created_by}`+ `/${this.currentBlog.blog_post_uuid}` );

            if (this.blogNumberIndex == 0) {
                this.firstPage = true;
            }

            if (e == "mobile") {
                var targetMobile = document.querySelector(".card");
                targetMobile.scrollIntoView({ behavior: "smooth" });
            } else {
                var targetDesktop = document.querySelector(".popup");
                targetDesktop.scrollIntoView({ behavior: "smooth" });
            }
        },
    },
};
</script>
<style scoped>
.bottom >>> p {
    min-height: 16px;
}
.paragraph >>> a {
    color: #11c6d1;
    font-size: 16px;
}
.paragraph >>> h1 {
    margin: 16px 0;
    font-size: 32px;
}
.paragraph >>> h2 {
    margin: 16px 0;
    font-size: 26px;
}
.paragraph >>> h3 {
    margin: 16px 0;
    font-size: 20px;
}
.paragraph >>> img {
    max-width: 100%;
    object-fit: cover;
    margin: 16px 0;
}
.paragraph >>> p {
    font-size: 16px;
}
</style>
<style scoped>
.bottom >>> p {
    min-height: 16px;
}
.paragraph >>> p {
    font-size: 16px;
}
</style>

<style scoped lang="scss">
* {
    text-align: left;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
p {
    font-size: 16px !important;
}

a {
    text-decoration: none;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.card {
    width: 740px;
    //height: 42.5rem;
    display: flex;
    flex-direction: column;
    background-color: #1b1c1f;
    margin: auto auto 80px auto;
    border: none;
}
h4 {
    font-size: 24px;
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
}
.share-row {
    display: flex;
}
.navigation-row {
    margin-top: 33px;
    margin-bottom: 42px;
    display: flex;
    justify-content: space-between;
    padding-inline: 38px;

    div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    p {
        padding: 0 8px;
        color: rgba(111, 115, 129, 1);
    }
    div:hover {
        cursor: pointer;
        p {
            color: #ceceda;
        }
    }
    p:hover {
        color: #ceceda;
    }
}
.top {
    width: 100%;
    min-height: 18rem;
    max-height: 29rem;

    img {
        width: 100%;
        height: 100%;
        max-height: 29rem;
        object-fit: cover;
    }
}
.row-one-left {
    display: flex;
    justify-content: center;
    align-items: center;
}
.desc {
    width: 70%;
}
.popup {
    padding-top: 85px;
    padding-bottom: 100px;
    width: calc(100% - 16.25rem);
    min-height: 100vh;
    background-color: #1b1c1f;
    overflow: scroll;
}
.top {
    display: flex;
    align-items: center;

    margin-bottom: 1.125rem;
    margin-top: 1rem;
    padding: 18px 38px;
}

.top p {
    padding-inline: 2.5rem;
    font-size: 14px;
    color: #ceceda;
    line-height: 2.125rem;
    padding-bottom: 0.688rem;
    font-weight: 500;
}
.row-one {
    min-height: 169px;
    background-color: #202122;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 2.625rem;
}
.svg_img {
    margin-right: 38px;
    padding-top: 0rem;
    width: 186px;
}
.mobile {
    display: none !important;
}
.row-one div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 1.875rem;
    padding-inline: 38px;
    padding-bottom: 1.875rem;
    //border:1px solid rgba(111, 115, 129, 1);
}

.tags {
    display: flex;
    margin-bottom: 1.125rem;
}

.tag {
    color: white;
    border: 1px solid #ffc695;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 0.993rem;
    padding-inline: 1rem;
    padding-block: 0.25rem;
    border-radius: 33px;
    transition: all 0.5s ease;
    cursor: pointer;

    &:not(:last-child) {
        margin-right: 1rem;
    }

    &:hover {
        background-color: #ffc695;
        color: white;
    }
}
.row-one h2 {
    color: #ceceda;
    //rgba(111, 115, 129, 1);
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 1.063rem;
    padding-top: 12px;
}

.row-one p {
    text-align: start;
    color: #ceceda;
    padding-right: 0.5rem;
    font-size: 14px;
}
.back-arrow {
    margin-bottom: 56px;
    padding-left: 2.625rem;
    display: flex;
    justify-content: space-between;
    margin-right: 2.625rem;

    p {
        color: #ceceda;
    }
}
.back-arrow {
    p:hover,
    img:hover {
        cursor: pointer;
        opacity: 0.7;
        color: #ffffff !important;
    }
}

.paragraph {
    margin-bottom: 1.25rem;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    font-weight: 500;
    a {
        color: #11c6d1 !important;
    }
    p {
        font-size: 16px !important;
    }
}

h3 {
    color: #11c6d1;
    font-size: 1.5rem;
    line-height: 1.984rem;
    margin-bottom: 1.25rem;
}

@media screen and (max-width: 1024px) {
    .popup {
        padding-top: 85px;
        width: 100%;
        height: 100%;
    }
}

@media screen and (max-width: 768px) {
    .card {
        width: 100%;
    }
    .top {
        height: 25rem;
    }
}

@media screen and (max-width: 640px) {
    .mobile {
        display: flex !important;
    }
    .desktop {
        display: none !important;
    }
    .card {
        width: 100%;
        margin-inline: auto;
    }
    .svg_img {
        padding-right: 38px;
        padding-top: 3rem;
        width: 138px;
        display: none;
    }
    .top {
        display: flex;
    }
    .popup {
        padding-top: 30px;
    }
    .navigation-row {
        margin-left: 15px;
        margin-right: 15px;
    }
    .btn {
        padding-left: 0;
        width: 9.25rem;

        img {
            opacity: 1;
        }
    }
    .row-one {
        padding-inline: 38px;
    }
}

@media screen and (max-width: 425px) {
    .card {
        width: 100%;
        margin-inline: 0;
    }
}
</style>
